import axios from "axios";
import jsonpAdapter from "axios-jsonp";
import { setCookie, getCookie, eraseCookie, removeLoading } from "../utils";

export const postCookie = ({ callBack, params, endpoint }) => {
  axios
    .post(endpoint, params)
    .then(function (response) {
      callBack(response);
      removeLoading();
    })
    .catch(function (error) {
      alert("Incorrect Value");
      removeLoading();
      console.log(error);
    });
};

export const post = ({ params, endpoint }) =>
  axios
    .post(endpoint, params, {
      headers:
        getCookie("accessToken") || localStorage.getItem("accessToken")
          ? {
              Authorization:
                getCookie("accessToken") || localStorage.getItem("accessToken"),
            }
          : {},
    })
    .then(function (response) {
      const {
        data: { token },
      } = response;
      token && setCookie("accessToken", token, 90);
      token && localStorage.setItem("accessToken", token);
      return response.data;
    })
    .catch(function (error) {
      // eraseCookie('accessToken');
      if (error && error.message === "Request failed with status code 401") {
        eraseCookie("accessToken");
      }
      // window.location.href = '/';
      if (!window.navigator.onLine) {
        alert("Something went wrong");
      }
    });

export const patch = ({ params, endpoint }) =>
  axios
    .patch(endpoint, params, {
      headers:
        getCookie("accessToken") || localStorage.getItem("accessToken")
          ? {
              Authorization:
                getCookie("accessToken") || localStorage.getItem("accessToken"),
            }
          : {},
    })
    .then(function (response) {
      const {
        data: { token },
      } = response;
      token && setCookie("accessToken", token, 90);
      token && localStorage.setItem("accessToken", token);
      return response.data;
    })
    .catch(function (error) {
      // eraseCookie('accessToken');
      if (error && error.message === "Request failed with status code 401") {
        eraseCookie("accessToken");
      }
      // window.location.href = '/';
      if (!window.navigator.onLine) {
        alert("Something went wrong");
      }
    });

export const get = (url) =>
  axios
    .get(url, {
      headers:
        getCookie("accessToken") || localStorage.getItem("accessToken")
          ? {
              Authorization:
                getCookie("accessToken") || localStorage.getItem("accessToken"),
            }
          : {},
    })
    .then(function (response) {
      // handle success
      const {
        data: { token },
      } = response;
      token && setCookie("accessToken", token, 90);
      token && localStorage.setItem("accessToken", token);
      return response.data;
    })
    .catch(function (error) {
      // handle error
      if (error && error.message === "Request failed with status code 401") {
        eraseCookie("accessToken");
        // window.location.href = '/';
      }
      if (!window.navigator.onLine) {
        alert("Something went wrong");
      }
      throw new Error("Bad gateway", error.message);
    });

export const getLoc = (url) =>
  axios({
    url,
    adapter: jsonpAdapter,
  }).then((res) => {
    return res.data;
  });

export const del = (url) =>
  axios
    .delete(url, {
      headers:
        getCookie("accessToken") || localStorage.getItem("accessToken")
          ? {
              Authorization:
                getCookie("accessToken") || localStorage.getItem("accessToken"),
            }
          : {},
    })
    .then(function (response) {
      // handle success
      if (response) {
        const {
          data: { token },
        } = response;
        token && setCookie("accessToken", token, 90);
        token && localStorage.setItem("accessToken", token);
        return response.data;
      }
      return "success";
    })
    .catch(function (error) {
      // handle error
      // eraseCookie('accessToken');
      if (error && error.message === "Request failed with status code 401") {
        eraseCookie("accessToken");
      }
      // window.location.href = '/';
      if (!window.navigator.onLine) {
        alert("Something went wrong");
      }
    });

export const put = ({ params, endpoint }) =>
  axios
    .put(endpoint, params, {
      headers:
        getCookie("accessToken") || localStorage.getItem("accessToken")
          ? {
              Authorization:
                getCookie("accessToken") || localStorage.getItem("accessToken"),
            }
          : {},
    })
    .then(function (response) {
      // handle success
      if (response) {
        const {
          data: { token },
        } = response;
        token && setCookie("accessToken", token, 90);
        token && localStorage.setItem("accessToken", token);
        return response.data;
      }
      return "success";
    })
    .catch(function (error) {
      if (error && error.message === "Request failed with status code 401") {
        eraseCookie("accessToken");
      }
      // window.location.href = '/';
      if (!window.navigator.onLine) {
        alert("Something went wrong");
      }
    });
